/**
 *  测试用数据
 */

// 热力图
export const testHeatmapData = {
  // max: 100,
  data: [{a: 36.6408, o: 120.7728, v: 3},
    {a: 36.12341, o: 120.55, v: 1},
    {a: 36.12341, o: 120.55, v: 9},
    {a: 36.12341, o: 120.55, v: 8},
    {a: 36.12341, o: 120.55, v: 7},
    {a: 36.12341, o: 120.55, v: 6},
    {a: 36.12341, o: 120.55, v: 5}
  ]
}


// 热力图
export const testDeviceData = {
  // max: 100,
  data: [{lat: 35.51823901412712, lng: 119.63287353515625},
    {lat: 35.61425872774833, lng: 119.68917846679689},
    {lat: 35.644380711936954, lng: 119.94735717773439},]
}

// 热力图
export const testPortData = {
  // max: 100,
  data: [{lat: 36.197924226939875, lng: 120.14099121093751},
    {lat: 36.120351096926775, lng: 120.09704589843751},
    {lat: 36.07155157154837, lng: 120.14923095703126},
  ]
}


// 热力图
export const testPipeLineData = {
  // max: 100,
  data: [{
    pipelineType:'1',
    pipelineRoute:[['36.197924226939875','120.14099121093751'],['36.120351096926775','120.09704589843751'],['36.07155157154837','120.14923095703126']]
  }
  ]
}



